import React from 'react';
import styled from 'styled-components';
import AdminLayout from 'Components/Layout/AdminLayout';
import AdminNewJobComponent from 'Components/NewAdvertisement/AdminNewJob';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdminNewJob = () => {
  return (
    <AdminLayout>
      <ContentContainer>
        <AdminNewJobComponent />
      </ContentContainer>
    </AdminLayout>
  );
};
export default AdminNewJob;
